import React from "react";

export default React.createContext({
  ApiDriver: null,
  Blog: {
    tags: null,
    search_query: "",
  },
  query_parameters: {},
  searchedHelp: {},
  notification: () => {},
  modal: {
    show: () => {},
    contentChanged: () => {},
    hide: () => {},
    content: null,
  },
});
